<template>

    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="30%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">Confirm {{ entityType }} deletion</span>

                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text class="modal-height" style="text-align: left">

                        <span class="body-2">Deleting a {{ entityType }} will permanently remove it from the database.</span>

                    </v-card-text>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>


                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="confirm_pool_group_deletion_button" class="text-none" color="red" small dark @click="onDeletePoolGroup">Yes, delete
                            {{entityType}}
                        </v-btn>
                        <v-btn id="cancel_pool_group_deletion_button" class="text-none" small @click="close">No, keep {{ entityType }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>


</template>

<script>

    import {EventBus} from "../../../eventbus";
    import poolgroupinterface from "../../../interfaces/poolgroupinterface";
    import errormessagemanager from "../../../managers/errormessagemanager";

    export default {
        name: 'ConfirmPoolGroupDeletionModal',

        data: () => ({
            entityType: "pool group",
            error: false,
            errorMessage: null,
        }),

        props: {
            value: Boolean,

            poolGroup: {
                poolGroupId: null,
                name: null,
                description: null
            }
        },

        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {
            async onDeletePoolGroup() {
                this.clearAlert();
                
                let response = null;

                await poolgroupinterface.deletePoolGroup(this.poolGroup, requestResponse => {
                    response = requestResponse;
                });

                if (response != null && !response.error) {
                    await EventBus.$emit('poolGroupDeletionConfirmed');
                    
                    this.onShow = false;
                    this.poolGroup = null;
                } else {
                    errormessagemanager.getDeletionErrorMessage(response.status, message => {
                        this.errorMessage = message;
                    });
                    this.error = response.error;
                }
            },

            async close() {
                await EventBus.$emit("poolGroupDeletionClosed");
                this.onShow = false;
                this.poolGroup = null;
                
                this.clearAlert();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = "";
            }
        }
    }
</script>

<style>
    .modal-height {
        min-height: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/poolgroups/modals/ConfirmPoolGroupDeletionModal.vue